
import SurveyResponsePage from "@/pages/shared/surveys/SurveyResponsePage";

export default function AdminSurveyResponsePage() {
  return <SurveyResponsePage viewType="admin" />;
}
